<template lang="pug">
.v-product.product
	.product__top-btns
		.product__gallery-btn(@click="toggleCompareStatus")
			v-svg-icon.open-full__icon(icon="compare")
		.product__gallery-btn(@click="openGallery")
			v-svg-icon.open-full__icon(icon="open-full")
	.product__gallery-tags(v-if="product.topTags && product.topTags.length")
		.product__gallery-tag(v-for="tag of product.topTags") {{tag}}
	a.product__link(:href="activeProduct?.link")
		.product__visual(:class="product.className")
			.product__controller(v-if="!isSm && swiper && activeProduct && activeProduct.slides && activeProduct.slides.length > 1")
				.product__controller-item(v-for="(item, index) in activeProduct.slides" :key="index" @mouseover="handleMouseOver(index)")
			.slider-pagination.slider-pagination--black(v-if="activeProduct && activeProduct.slides && activeProduct.slides.length")
				.swiper-pagination( ref="pagination")
			v-loader(:loading="!swiper")
			v-swiper-slider(
				v-if="activeProduct && activeProduct.slides && activeProduct.slides.length"
				:options="computedOptions"
				:key="uniqueId"
				@swiper="initSwiper"
				@slideChange="slideChange"
				:pagination="swiper ? pagination : false"
				ref="swiperSlider")
					v-swiper-slide(v-for="({src, alt}, index) in activeProduct.slides" :key="index")
						.product-slide(v-if="src")
							img.product-slide__img(:src="src" :alt="alt")
	.product__body
		a.product__name(v-if="product.name" :href="activeProduct?.link") {{product.name}}
		.product__info
			.product__view
				.product__view-container(:style="{height: `${infoImageHeight}px`, width: `${computedWidth}px`}")
					img.product__view-img(v-if="product.image"
						ref="mini-img"
						:class="{'product__view-img--rotate': isRotate}"
						:style="{height: isRotate ? `${computedWidth + 1}px` : `${infoImageHeight}px`, width: isRotate ? `${infoImageHeight}px` : `${computedWidth}px`}"
						:src="product.image?.medium"
						:alt="product.image?.alt")
				.product__view-text(v-if="product.height && product.width" )
					.product__view-height {{product.height}}
					.product__view-separator x
					.product__view-width {{product.width}}
			.product__separator(v-if="product.type")
			.product__type(v-if="product.type") {{product.type}}
		.product__offers(v-if="product && product.collections && product.collections.length > 1")
			template(v-for="(item, index) in product.collections" :key="index" )
				.product__offers-item
					button.offer-item(:class="{'offer-item--active' : item.id === activeProduct.id}" @click="setActiveProduct(item)")
						.offers-item__img(v-if="item.preview && item.preview" :style="{backgroundColor: item.preview}")
	.slider-gallery(v-if="gallery")
		.slider-gallery__slider
			v-image-slider-gallery(:data-source="activeProduct" @close-gallery="closeGallery" :initial-index="activeIndex")
</template>

<script>
import {SwiperSlide} from 'swiper/vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue'
import uniqueId from '../scripts/helpers/uniqueId.js';
import scrollLock from "scroll-lock";
export default {
	mixins: [
		isMobMixin
	],
	props: {
		product: {
			type: Object,
			default: null
		},
	},
	components: {
		'v-swiper-slide': SwiperSlide
	},
	data() {
		return {
			activeProduct: null,
			swiper: null,
			activeIndex: null,
			uniqueId: uniqueId('swiper-'),
			pagination: {},
			infoImageHeight: 26,
			gallery: false,
			containerWidth: 'auto',
			isRotate: false,
			isVertical: false,
			compareStatus: false,
		}
	},
	watch: {
		product: {
			immediate: true,
			handler() {
					if(this.product.collections && this.product.collections.length) {
						const [first] = this.product.collections;
						this.activeProduct = first;
					}
				}
			},
		gallery() {
			if(this.gallery) {
				scrollLock.disablePageScroll(document.querySelector('.slider-gallery'));
			} else {
				scrollLock.enablePageScroll(document.querySelector('.slider-gallery'));
			}
		},
	},
	methods: {
		setActiveProduct(item) {
			this.activeProduct = item;
			this.handleMouseOver(0);
		},
		initSwiper(swiper) {
			this.pagination = {
				el: this.$refs['pagination'],
				type: 'bullets',
				clickable: true
			}
			setTimeout(() => {
				this.swiper = swiper;
			},300)
		},
		handleMouseOver(index) {
			this.activeIndex = index;
			this.swiper.slideTo(this.activeIndex);
		},
		slideChange(slider) {
			this.activeIndex = slider.realIndex;
		},
		closeGallery() {
			this.gallery = false
			this.$emit('open-gallery', this.activeIndex)
		},
		openGallery() {
			this.gallery = true
			this.$emit('open-gallery', this.activeIndex)
		},
		async toggleCompareStatus() {
			if (!this.product?.id) return;

			const itemId = this.product.id;

			if (this.compareStatus) {
				// this.$store.commit('compare/removeItem', itemId)
				this.$store.dispatch('compare/remove', [itemId]);
			} else {
				// this.$store.commit('compare/addItem', itemId)
				this.$store.dispatch('compare/add', [itemId]);
			}

			this.compareStatus = !this.compareStatus;
		},
	},
	computed: {
		computedOptions() {
			let result = {
				slidesPerView: 1,
				spaceBetween: 0,
				pagination: this.pagination,
				loop: true,
				navigation: 'none',
				watchOverflow: true,
				effect: 'creative'
			};
			if (this.options) {
				Object.keys(this.options).forEach((key) => {
					if (typeof this.options[key] !== 'undefined') {
						result[key] = this.options[key];
					}
				});
			}
			return result;
		},
		computedWidth() {
			if(this.product.height && this.product.width) {
				const min = Math.min(this.product.height, this.product.width);
				const max = Math.max(this.product.height, this.product.width);
				return this.infoImageHeight*(max/min)
			}
			return 0;
		}
	},
	created() {
		this.$nextTick(() => {
			this.pagination = {
				el: this.$refs['pagination'],
				type: 'bullets',
				clickable: true
			}

			this.$refs['mini-img'].addEventListener('load', () => {
				this.isRotate = this.$refs['mini-img'].naturalHeight > this.$refs['mini-img'].naturalWidth
			})

		})
	},
	mounted () {
			setTimeout(() => {
			this.compareStatus = this.$store.state.compare.items.some(item => item.id == this.product.id);
		}, 500)
	},
};
</script>